<template>
  <div>
    <CubePage type="myorder-view" title="导游订单" :backurl="'guideHome'">
      <div slot="content">
        <van-sticky :offset-top="44">
          <van-search placeholder="请输入团队名称/导游/联系电话" v-model="row.search" @search="onSearch" show-action>
            <div slot="action" @click="onSearch">
              <van-button type="primary">搜索</van-button>
            </div>
          </van-search>
          <van-swipe :loop="false" :width="60" :height="30" :show-indicators="false" style="margin-left:10px;"
            class="hd">
            <van-swipe-item style="width: auto" v-for="(item, index) in orderStatusList" :key="index">
              <van-button :class="row.status == item.value ? 'van-button-active' : ''" @click="onTagBtn(item.value)"
                plain round size="mini" style="font-size: 12px;">{{ item.text }}</van-button>
            </van-swipe-item>
          </van-swipe>
          <div class="cal-box">
            <div class="cal-sc">
              <div class="title">出团时间</div>
              <div class="cals" @click="calshow = true">
                <span class="ri" v-if="row.use_date_start">{{ row.use_date_start }}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择开始日期</span>
                <van-icon name="notes-o" size="25" />
              </div>
              <div class="dj">到</div>
              <div class="cals" @click="calshow = true">
                <span class="ri" v-if="row.use_date_end">{{ row.use_date_end }}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择结束日期</span>
                <van-icon name="notes-o" size="25" />
              </div>
            </div>
            <van-swipe :loop="false" :width="60" :height="30" :show-indicators="false" style="margin-left:10px;"
              class="hd">
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '全部' ? 'van-button-active' : ''" @click="onTagCalBtn('全部')" plain
                  round size="mini" style="font-size: 12px;">全部</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '今天' ? 'van-button-active' : ''" @click="onTagCalBtn('今天')" plain
                  round size="mini" style="font-size: 12px;">今天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '明天' ? 'van-button-active' : ''" @click="onTagCalBtn('明天')" plain
                  round size="mini" style="font-size: 12px;">明天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '后天' ? 'van-button-active' : ''" @click="onTagCalBtn('后天')" plain
                  round size="mini" style="font-size: 12px;">后天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '近7天' ? 'van-button-active' : ''" @click="onTagCalBtn('近7天')" plain
                  round size="mini" style="font-size: 12px;">近7天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '近两周' ? 'van-button-active' : ''" @click="onTagCalBtn('近两周')" plain
                  round size="mini" style="font-size: 12px;">近两周</van-button>
              </van-swipe-item>
            </van-swipe>
          </div>
        </van-sticky>

        <div style="z-index: -10;">
          <van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
            <template #image>
              <img src="@/assets/img/empty.png" alt>
            </template>
          </van-empty>
          <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
              :immediate-check="false">
              <div class="orderitem van-clearfix" v-for="(item, index) in OrderList" :key="index">
                <div class="ordertitle">
                  <p>团队名称：{{ item.team_name }}</p>
                  <p class="colorred">
                    <span>{{ item.status_text }}</span>
                  </p>
                </div>
                <van-card :num="1">
                  <template #price-top>
                    <div class="carflex">
                      <div class="carddesc">
                        <span>出团时间：</span>
                        <span>{{ item.start_time }}</span>
                      </div>
                      <div class="carddesc">
                        <span>完团时间：</span>
                        <span>{{ item.end_time }}</span>
                      </div>
                      <div class="carddesc">
                        <span>天数：</span>
                        <span>{{ item.days }}</span>
                      </div>
                      <div class="carddesc">
                        <span>人数：</span>
                        <span>{{ item.team_number }}</span>
                      </div>
                      <div class="carddesc">
                        <span>团队类型：</span>
                        <span>{{ item.team_type_text }}</span>
                      </div>
                      <div class="carddesc">
                        <span>职级：</span>
                        <span>{{ item.guide_rank_text }}</span>
                      </div>
                      <div class="carddesc">
                        <span>价格：</span>
                        <span>{{ item.total_price }}</span>
                      </div>
                      <div class="carddesc">
                        <span>状态：</span>
                        <span>{{ item.status_text }}</span>
                      </div>
                    </div>
                  </template>
                  <template #footer>
                    <div style="margin-top: 10px;">
                      <van-button style="border-radius: 4px;" v-if="item.btnstatus" size="small" type="info"
                        @click="goAccept(item)">{{
                          item.btnstatus }}</van-button>
                      <van-button style="border-radius: 4px;" size="small" type="primary"
                        @click="goDetail(item.id)">详情</van-button>
                    </div>
                  </template>
                </van-card>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <van-overlay :show="showMemo" @click="showMemo = false">
          <div class="wrapper" @click.stop>
            <div class="block">
              <h4>评价</h4>
              <van-field v-model="message" rows="2" :autosize="autosize" label="填写评价" type="textarea" maxlength="100"
                placeholder="请输入评价" show-word-limit clearable />
              <div class="btn">
                <van-button type="primary" size="small" plain @click="showMemo = false">关闭</van-button>
                <van-button type="primary" size="small" @click="confirmbtn">确认</van-button>
              </div>
            </div>
          </div>
        </van-overlay>
      </div>
    </CubePage>
    <cube-view></cube-view>
    <SelectZf ref="selectZf" />
    <van-calendar v-model="calshow" type="range" @confirm="onConfirm" :allow-same-day="true" :min-date="minDate" />
  </div>
</template>


<script>
import CubeView from "@/components/TP/cube-view";
import CubePage from "../../TP/cube-page.vue";
import SelectZf from '../../NewPages/selectzf.vue'
import * as udate from "@/utils/date";
import * as util from "@/utils/network";
import {
  Toast,
} from 'vant';
export default {
  components: {
    CubePage,
    CubeView,
    SelectZf
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      OrderList: [],
      isNoData: false,
      pageIndex: 1,
      pageTotal: 0,
      selectcaltag: "",
      calshow: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      row: {
        status: "",
        search: "",
        use_date_start: "",
        use_date_end: ""
      },
      orderStatusList: [{
        text: '全部',
        value: ''
      },
      {
        text: '待确认',
        value: '12'
      },
      {
        text: '待出团',
        value: '13'
      },
      {
        text: '进行中',
        value: '14'
      },
      {
        text: '待评价',
        value: '15'
      },
      {
        text: '已拒绝',
        value: '20'
      }],
      reservation: null,
      showMemo: false,
      message: '',
      autosize: {
        minHeight: 100
      },
    };
  },
  created() {
    this.get_my_order();
  },
  methods: {
    //点击按钮
    goAccept(item) {
      console.log(item);
      this.onlyId = item.id;
      this.reservation = item;
      if (item.btnstatus && item.btnstatus !== '评价') {
        this.$dialog.confirm({
          title: '提示',
          message: `确认进行${item.btnstatus}操作吗？`
        }).then(() => {
          this.ajaxPost(item);
        }).catch(() => { });
      } else {
        this.showMemo = true
      }
    },
    // 评价
    confirmbtn() {
      let message = this.message;
      if (!message) {
        return Toast('评价不能为空')
      }
      this.showMemo = false;
      this.ajaxPost(message);
    },
    ajaxPost(message) {
      let url = '/addons/litestore/api.guide/operate';
      let params = {
        id: this.onlyId,
        status: this.reservation.status,
      }
      if (message) {
        params.guider_emo = this.message
      }
      util.post(url, params, (result) => {
        Toast(result.msg)
        if (result.code == 1) {
          setTimeout(() => {
            this.OrderList = [];
            this.get_my_order();
          }, 1000);
        }
      });
    },
    // 跳转到详情页面
    goDetail(id) {
      this.$router.push({
        path: '/guideTravelOrderDetail',
        query: {
          id: id,
        }
      })
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      let that = this;
      that.clearContainer();
      const [start, end] = date;
      that.calshow = false;
      that.row.use_date_start = that.formatDate(start);
      that.row.use_date_end = that.formatDate(end);
      that.get_my_order();
    },
    onTagCalBtn(v) {
      let that = this;
      if (that.selectcaltag == v) {
        return;
      }
      this.clearContainer();
      let start = "";
      let end = "";
      let fmt = "yyyy/MM/dd";
      start = udate.getDatenow(fmt);
      switch (v) {
        case "今天":
          end = that.GetDateStr(0, fmt);
          break;
        case "明天":
          start = that.GetDateStr(1, fmt);
          end = that.GetDateStr(1, fmt);
          break;
        case "近7天":
          end = that.GetDateStr(7, fmt);
          break;
        case "后天":
          start = that.GetDateStr(2, fmt);
          end = that.GetDateStr(2, fmt);
          break;
        case "近两周":
          end = that.GetDateStr(14, fmt);
          break;
        case "全部":
          end = "";
          start = "";
          break;
        default:
          end = "";
          break;
      }
      that.row.use_date_start = start;
      that.row.use_date_end = end;
      that.selectcaltag = v;
      that.get_my_order();
    },
    onTagBtn(v) {
      let that = this;
      if (that.row.status == v) {
        return;
      }
      that.row.status = v;
      that.onSearch();
    },
    onSearch() {
      this.clearContainer();
      this.pageIndex = 1;
      this.get_my_order();
    },
    // 上滑加载更多
    onLoad() {
      let that = this;
      // 异步更新数据
      setTimeout(() => {
        that.pageIndex++;
        if (that.OrderList < 1 || that.finished) return;
        if (that.refreshing) {
          that.OrderList = [];
          that.pageIndex = 1;
          that.refreshing = false;
        }
        that.get_my_order();
      }, 1000);
    },
    // 获取数据
    get_my_order() {
      let url = "/addons/litestore/api.guide/orders";
      let that = this;
      that.loading = true;
      that.row.page = that.pageIndex;

      let { page, search, use_date_end, use_date_start, status } = that.row;
      let obj = {
        team_name: search,
        status,
        page,
        start_time: use_date_start,
        end_time: use_date_end,
        limit: 10
      }

      //这里直接调用网络接口
      util.post(url, obj, (result) => {

        let data = JSON.parse(JSON.stringify(result))
        //这里对状态 进行分类
        that.pageTotal = data.data.total;

        if (that.pageTotal < 1) {
          // that.finished = true;
          that.isNoData = true;
          return;
        } else {
          that.isNoData = false;
        }
        that.loading = false;
        if (data.data.list == null || data.data.list.length === 0) {
          // 加载结束
          that.finished = true;
          return;
        }
        // 将新数据与老数据进行合并
        that.OrderList = that.OrderList.concat(data.data.list);
        if (that.OrderList.length > 0) {
          that.OrderList.forEach(item => {
            if (item.status == '13') {
              item.btnstatus = '出团'
            }
            if (item.status == '14') {
              item.btnstatus = '完团'
            }
            if (item.status == '15') {
              item.btnstatus = '评价'
            }
            if (item.status == '20') {
              item.btnstatus = ''
            }
          });
        }
        // console.log(that.isNoData)
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.OrderList.length >= that.pageTotal) {
          that.finished = true;
        }
      });
    },
    GetDateStr(AddDayCount) {
      var day = new Date();
      day.setDate(day.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = day.getFullYear();
      var m = day.getMonth() + 1; //获取当前月份的日期
      var d = day.getDate();
      m = String(m < 10 ? "0" + m : m);
      d = String(d < 10 ? "0" + d : d);

      return y + "/" + m + "/" + d;
    }, // 初始化数据
    clearContainer() {
      let that = this;
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      that.OrderList = [];
      that.isNoData = false;
      that.pageIndex = 1;
      that.pageTotal = 0;
    },
    //下拉刷新
    onRefresh() {
      this.finished = false;
      this.onLoad();
    }
  }
};
</script>
<style lang="less" type="text/css">
.van-sticky {
  background: #fafafa !important;
}
</style>
<style lang="less" scoped="scoped">
@import url("../../../assets/css/order.css");
@import url("../../../assets/css/listboxless.less");

.van-search {
  .van-search__action {
    line-height: 0;
  }

  .van-button {
    height: 34px;
  }
}

.hd {
  .van-button {
    flex-shrink: 0;
    margin-right: 6px;
  }

  .van-button-active {
    border: 1px solid #55aa7f;
    color: #55aa7f;
  }

}

.van-button--mini {
  padding: 0 10px !important;
}



.cal-box {
  background-color: #ffffff;
}

.cal-sc {
  margin-top: 10px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  .title {
    color: #989898;
    padding-right: 10px;
  }

  .dj {
    margin: 0 5px;
  }

  .cals {
    .ri {
      font-weight: 600;
    }

    .van-icon {
      color: #55aa7f;
      margin-left: 10px;
      vertical-align: middle;
    }
  }

}

.footerflex {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 0;
  color: #ff0000;
  font-size: 14px;
}

.hxdialog {
  border-bottom: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;

  .van-card__title {
    font-size: 15px;
    padding-bottom: 5px;
  }

  .carddesc,
  .van-card__num {
    font-size: 13px;
    padding: 3px 0;
  }
}

.contentsheet {
  padding: 16px 16px 20px;
  margin: 0;

  .btnmini {
    width: 100%;
    text-align: right;
    padding-top: 16px;

    .van-button--small {
      width: 70px;
    }
  }
}
</style>
<style type="text/css" lang="less" scoped="scoped">
.van-card {
  background: transparent !important;
}

.slide {
  overflow-x: auto;
  white-space: nowrap;
  box-sizing: border-box;

  .slide-item {
    display: inline-block;
    width: 100px;
    height: 100px;
    background-color: #ccc;
    margin-right: 10px;
  }
}

.carflex {
  flex-flow: wrap;

  .carddesc {
    width: 50%;
  }
}

.van-card__num {
  display: none;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .block {
    width: 80%;
    min-height: 200px;
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;

    h4 {
      text-align: center;
      margin-bottom: 20px;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 15px;

      button {
        margin-left: 15px;
        padding: 0 30px;
        border-radius: 4px;
      }
    }
  }
}
</style>
